import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-0 z-1 position-relative" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-gray-100",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"margin":"-17px 0 0 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "mb-0" }, "Rooms Availability", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
              return (_openBlock(), _createElementBlock("li", { key: period }, [
                _createElementVNode("button", {
                  class: "dropdown-item text-secondary py-2 px-3",
                  onClick: ($event: any) => (_ctx.changePeriod(period))
                }, _toDisplayString(period), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: "380",
              options: _ctx.roomsAvailability,
              series: _ctx.rooms
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}